<template>
  <div class="approval-customer-changes-index">
    <Filters
      :filters="approvalCustomerChangesFilters"
      filter-key="approvalCustomerChanges"
      :initial-data="filtersStatus.approvalCustomerChanges"
      :loading="filtersLoading"
    />

    <TableWrapper
      :tableColumns="approvalCustomerChangesColumns"
      :enableSelection="true"
      table-key="approvalCustomerChanges"
      row-key="id"
      @viewDiff="openViewDiffModal"
      @accept="acceptSampleEdit"
      @refuse="refuseSampleEdit"
    />

    <ViewDiffModal
      v-if="diffData"
      :diffData="diffData"
      @dialogClose="diffData = null"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import Filters from '@/components/Filters.vue';
  import TableWrapper from '@/components/TableWrapper.vue';
  import abortControllerMixin from '@/mixins/abortControllerMixin';
  import filterLoadingMixin from '@/mixins/filterLoadingMixin';
  import axios from 'axios';

  import {
    approvalCustomerChangesFilters,
    approvalCustomerChangesColumns,
  } from '@/config';
  import { approvalCustomerChangesApi } from '@/api';
  // import { SAMPLE_ACTIONS, SAMPLE_ACTIONS_DESC } from '@/config/constants';

  import ViewDiffModal from './ViewDiffModal.vue';

  export default {
    name: 'ApprovalCustomerChangesIndex',
    components: {
      TableWrapper,
      Filters,
      ViewDiffModal,
    },
    mixins: [abortControllerMixin, filterLoadingMixin],
    data() {
      return {
        approvalCustomerChangesFilters,
        approvalCustomerChangesColumns,
        diffData: null,
        // massiveActionsOptions: [
        //   {
        //     label: this.$t(`enums.sampleActions.${SAMPLE_ACTIONS_DESC[SAMPLE_ACTIONS.ACCEPT]}`),
        //     value: SAMPLE_ACTIONS.ACCEPT,
        //   },
        //   {
        //     label: this.$t(`enums.sampleActions.${SAMPLE_ACTIONS_DESC[SAMPLE_ACTIONS.REJECT]}`),
        //     value: SAMPLE_ACTIONS.REJECT,
        //   },
        // ],
      };
    },
    computed: {
      ...mapGetters(['tableFilters', 'filtersStatus']),
    },
    methods: {
      ...mapActions([
        'updateTableRows',
        'updateTableCount',
        'parseQueryStringStatus',
      ]),
      async tableRows() {
        const signal = this.createAbortController();
        this.filtersLoading = true;
        let aborted = false;
        try {
          const approvalCustomerChangesIndex =
            await approvalCustomerChangesApi.index(
              this.tableFilters('approvalCustomerChanges'),
              this.filtersStatus.approvalCustomerChanges,
              { signal }
            );
          const approvalCustomerChangesCount =
            await approvalCustomerChangesApi.count(
              this.filtersStatus.approvalCustomerChanges,
              { signal }
            );

          this.updateTableRows({
            tableKey: 'approvalCustomerChanges',
            rows: approvalCustomerChangesIndex.data,
          });
          this.updateTableCount({
            tableKey: 'approvalCustomerChanges',
            count: approvalCustomerChangesCount.data.count,
          });
        } catch (error) {
          if (axios.isCancel(error)) {
            aborted = true;
            return;
          }
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        } finally {
          if (!aborted) {
            this.filtersLoading = false;
          }
        }
      },
      async acceptSampleEdit(row) {
        this.$confirm(
          this.$t('approvalCustomerChanges.approveConfirm.message'),
          this.$t('approvalCustomerChanges.approveConfirm.title'),
          {
            confirmButtonText: this.$t('global.confirm'),
            cancelButtonText: this.$t('global.cancel'),
            type: 'info',
          }
        )
          .then(async () => {
            await approvalCustomerChangesApi.acceptSampleEdit(row.sampleId);
            await this.tableRows();
            this.$notify({
              showClose: true,
              type: 'success',
              message: this.$t('global.success'),
            });
          })
          .catch((error) => {
            this.$notify({
              showClose: true,
              type: 'error',
              message: error.response.data.error.message,
            });
          });
      },
      async refuseSampleEdit(row) {
        this.$confirm(
          this.$t('approvalCustomerChanges.rejectConfirm.message'),
          this.$t('approvalCustomerChanges.rejectConfirm.title'),
          {
            confirmButtonText: this.$t('global.confirm'),
            cancelButtonText: this.$t('global.cancel'),
            type: 'warning',
          }
        )
          .then(async () => {
            await approvalCustomerChangesApi.refuseSampleEdit(row.sampleId);
            await this.tableRows();
            this.$notify({
              showClose: true,
              type: 'success',
              message: this.$t('global.success'),
            });
          })
          .catch((error) => {
            this.$notify({
              showClose: true,
              type: 'error',
              message: error.response.data.error.message,
            });
          });
      },
      // async bulkApply(action, selectedRows) {
      //   this.selectedSamples = selectedRows;
      //   switch (action) {
      //     case SAMPLE_ACTIONS.ACCEPT:
      //       console.log('accept');
      //       break;
      //     case SAMPLE_ACTIONS.REJECT:
      //       console.log('reject');
      //       break;
      //     default:
      //       break;
      //   }
      // },
      openViewDiffModal(row) {
        this.diffData = row;
      },
    },
    created() {
      this.parseQueryStringStatus(this.$route.query);
      this.tableRows();
    },
    beforeRouteUpdate(to, from, next) {
      this.parseQueryStringStatus(to.query);
      this.tableRows();
      next();
    },
  };
</script>
